interface SectionTitleProps {
  title: string;
  subtitle?: string;
  href?: string;
}

export default function SectionTitle({ title, subtitle, href }: SectionTitleProps) {
  const content = (
    <div className="flex items-end justify-between mb-6">
      <div>
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>{title}</h2>
        {subtitle && <p className="text-sm text-foreground-500 mt-1">{subtitle}</p>}
      </div>
      {href && (
        <a href={href} className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap">
          查看更多 <i className="ri-arrow-right-line"></i>
        </a>
      )}
    </div>
  );

  if (href) {
    return <a href={href}>{content}</a>;
  }
  return <>{content}</>;
}